// extracted by mini-css-extract-plugin
module.exports = {"richTextList":"text-with-image-richtex_richTextList__zENzl"};